import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';

import { postSignIn } from '@jetslash/market-frontend-shared-core/src/api/userApi';
import { ISignInForm, SignInFormDefinition } from '@jetslash/market-frontend-shared-core/src/forms/signIn';

import EasyForm from '@/components/forms/EasyForm';
import { track } from '@/utility/eventTracking/eventTracker';
import { EVENT_LOG_IN_STARTED } from '@jetslash/market-frontend-shared-core/src/utilities/eventTracking/events';
import { setInMemoryToken } from '@/utility/auth/authWrapper';
import PropTypes from 'prop-types';
import Row from '../layout/Row';
import Col from '../layout/Col';
import CTAButton from '../design/CTAButton';
import InputField from './fields/InputField';

const SignInForm = ({ onSignInSuccess }) => {
  const formDefinition = new SignInFormDefinition();
  // Initial state is used to lock in the initial values of the form
  const [initialFormValues] = useState<ISignInForm>(formDefinition.initialValues());

  useEffect(() => {
    track(EVENT_LOG_IN_STARTED, {});
  }, []);

  const onSubmit = async ({ email, password }: ISignInForm, { resetForm }) => {
    try {
      const { data } = await postSignIn({ email, password });
      setInMemoryToken(data.data.jwtToken);
      onSignInSuccess(data);
    } catch (err) {
      resetForm({ values: formDefinition.initialValues(email) });
      throw err;
    }
  };

  return (
    <div style={{ marginLeft: 5, marginRight: 5 }}>
      <Formik
        initialValues={initialFormValues}
        validationSchema={formDefinition.validationSchema}
        onSubmit={onSubmit}
        validateOnMount
      >
        <EasyForm keepLoadingOnSuccess>
          {({ onClickSubmit, submitDisabled }) => (
            <>
              <InputField name="email" placeholder="Email address" type="email" autoComplete="email" />
              <InputField name="password" placeholder="Password" type="password" />
              <Row style={{ marginLeft: 5, marginRight: 5, marginTop: 10 }}>
                <Col span={24}>
                  <CTAButton onClick={onClickSubmit} disabled={submitDisabled} text="Log in" icon="lock" />
                </Col>
              </Row>
            </>
          )}
        </EasyForm>
      </Formik>
    </div>
  );
};

SignInForm.propTypes = { onSignInSuccess: PropTypes.func.isRequired };

export default SignInForm;
